import { useEffect } from 'react';
import { DialogCalendarLayout } from '../../../calendar/layouts/dialog/dialog-calendar-layout';
import type { UseCalendarReturn } from '../../../calendar/provider/use-calendar';

export const CalendarDialogCalendar = (props: Omit<UseCalendarReturn, 'children'>) => {
  useEffect(() => {
    setTimeout(() => props.focusDate(), 0);
  }, []);
  return <DialogCalendarLayout {...props} />;
};
